import React, { useState } from "react";
// import alertIcon from "../../../images/alert.png";
import useStyles from "../../components/common/model/styles";
import Popup from "../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../assets/closeModel.png";
import CustomButton from "../../components/common/button/CustomButton";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import { resetSubscriptionLocal } from "../../store/reducers/publicSlice";
interface ActivationPopupProps {
  title?: string;
  open: boolean;
  onHide?: () => void;
  alertModalShow: boolean;
  setAlertModelShow: (show: boolean) => void;
  setIsdurationError?: any;
  setIsPaymentError?: any;
  setIsCalledAction?: any;
}
const ResetFormAlert: React.FC<ActivationPopupProps> = ({
  onHide,
  alertModalShow,
  setAlertModelShow,
  setIsdurationError,
  setIsPaymentError,setIsCalledAction
}) => {
  const [isAction, setIsAction] = useState(false);
  const dispatch = useDispatch();
  const classes = useStyles();

  const submitHandler = () => {
    dispatch(resetSubscriptionLocal());  
    setIsCalledAction(true);
    setAlertModelShow(false);
    setIsdurationError(false);
setIsPaymentError(false);
  };
  const closeModel = () => {
    setAlertModelShow(false);
  };
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("xs"); // Adjust the type definition
  return (
    <Popup
      open={alertModalShow}
      title={"Alert"}
      onHide={closeModel}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          <CustomButton variant="outlined" title="No" onClick={closeModel} />
          <CustomButton title="Yes" onClick={submitHandler} />
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          {/* <img src={alertIcon} alt="icons" /> */}
          {isAction ? (
            <Alert severity="error">
              {isAction || "Access denied! Please try again"}
            </Alert>
          ) : (
            <Alert
              sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
              severity="warning"
            >
              Are you sure, you want to reset the data entered in the form?
            </Alert>
          )}
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default ResetFormAlert;
